import { graphql } from "gql.tada";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { FootnoteFragment } from "@queries/fragments/FootnoteFragment";
import { TaggedEntryHeroFragment } from "@queries/fragments/TaggedEntryHeroFragment";
import { CaseStudyBodySectionFragment } from "@queries/fragments/CaseStudyBodySectionFragment";

export const GetCaseStudyPageBySlug = graphql(
  `
    query GetCaseStudyPageBySlug(
      $slug: String
      $locale: String
      $preview: Boolean
    ) {
      caseStudyPageCollection(
        where: { slug: $slug }
        limit: 1
        locale: $locale
        preview: $preview
      ) {
        items {
          __typename
          sys { id }
          # Locale gate: the page entry falls back to en-US when not explicitly
          # set for the requested locale, but a non-null title means the page
          # served there and the resolver renders NotFound.
          localeGate: title(useFallbackLocale: false)
          showPageInLocales
          slug
          title
          theme { ...ThemeFragment }
          metadata { ...MetadataFragment }
          localizationMarkets
          overview {
            sys { id }
            title
            descriptionRichText {
              json
              links {
                entries {
                  inline {
                    sys { id }
                    __typename
                    ... on Footnote { ...FootnoteFragment }
                  }
                }
              }
            }
          }
          hero {
            ...TaggedEntryHeroFragment
          }
          caseStudyBodyCollection(limit: 3) {
            items {
              sys { id }
              ...CaseStudyBodySectionFragment
            }
          }
          caseStudyInsights {
            sys { id }
            title
            blocksCollection (limit:3) {
              items { ...RichEntryFragment }
            }
          }
          adFormatsCarousel {
            sys { id }
          }
          highlightedQuotation {
            sys { id }
            quotation
            attributionName
            attributionPosition
            attributionCompany
          }
          exploreMore {
            ...RichEntryFragment
          }
          ctaFooter {
            sys { id }
            variant
            isVertical
            title
            titleRichText { json }
            cta { ...LinkFragment }
            backgroundImage { url title }
          }
        }
      }
    }
  `,
  [
    LinkFragment,
    IconGridFragment,
    MetadataFragment,
    ThemeFragment,
    RichEntryFragment,
    FootnoteFragment,
    TaggedEntryHeroFragment,
    CaseStudyBodySectionFragment,
  ]
);
